"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResetPasswordErrorCode;
(function (ResetPasswordErrorCode) {
    ResetPasswordErrorCode[ResetPasswordErrorCode["TokenExpired"] = 1] = "TokenExpired";
    ResetPasswordErrorCode[ResetPasswordErrorCode["GeneralError"] = 2] = "GeneralError";
})(ResetPasswordErrorCode = exports.ResetPasswordErrorCode || (exports.ResetPasswordErrorCode = {}));
var FormMode;
(function (FormMode) {
    FormMode[FormMode["Create"] = 0] = "Create";
    FormMode[FormMode["Edit"] = 1] = "Edit";
})(FormMode = exports.FormMode || (exports.FormMode = {}));
var LoadState;
(function (LoadState) {
    LoadState[LoadState["None"] = 1] = "None";
    LoadState[LoadState["Error"] = 2] = "Error";
    LoadState[LoadState["Loading"] = 3] = "Loading";
    LoadState[LoadState["Loaded"] = 4] = "Loaded";
})(LoadState = exports.LoadState || (exports.LoadState = {}));
var UserRole;
(function (UserRole) {
    UserRole["USER"] = "USER";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["PUBLISHER"] = "PUBLISHER";
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["ROOT_ADMIN"] = "ROOT_ADMIN";
    UserRole["VIEW_ALL"] = "VIEW_ALL";
    UserRole["READ_ONLY"] = "READ_ONLY";
    UserRole["MILKSHAKE_ADMIN"] = "MILKSHAKE_ADMIN";
    UserRole["VIEW_AS"] = "VIEW_AS";
    UserRole["READ_ONLY_ADMIN"] = "READ_ONLY_ADMIN";
    UserRole["VIEW_AS_STRICT"] = "VIEW_AS_STRICT";
    UserRole["REPORTING_ONLY"] = "REPORTING_ONLY";
    UserRole["INVITE_VIDAZOO"] = "INVITE_VIDAZOO";
    UserRole["CMS_ONLY"] = "CMS_ONLY";
    UserRole["DEMAND_ONLY"] = "DEMAND_ONLY";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var DayField;
(function (DayField) {
    DayField["DATE"] = "date";
    DayField["DAY"] = "day";
})(DayField = exports.DayField || (exports.DayField = {}));
var FieldType;
(function (FieldType) {
    FieldType["SUMABLE"] = "sumable";
    FieldType["AVERAGABLE"] = "averagable";
    FieldType["CALCULATED"] = "calculated";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
var ReportFieldValueType;
(function (ReportFieldValueType) {
    ReportFieldValueType[ReportFieldValueType["ORIGINAL"] = 0] = "ORIGINAL";
    ReportFieldValueType[ReportFieldValueType["COMPARE"] = 1] = "COMPARE";
    ReportFieldValueType[ReportFieldValueType["DELTA"] = 2] = "DELTA";
    ReportFieldValueType[ReportFieldValueType["DELTA_PCT"] = 3] = "DELTA_PCT";
})(ReportFieldValueType = exports.ReportFieldValueType || (exports.ReportFieldValueType = {}));
exports.TimePreset = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "weektodate", label: "Week to Date" },
    { value: "lastmonth", label: "Last Month" },
    { value: "monthtodate", label: "Month to Date" },
];
exports.DashboardReportingTimePreset = exports.TimePreset
    .concat([{ value: "custom", label: "Custom" }]);
exports.ReportingTimePreset = [{ value: "now", label: "Now" }]
    .concat(exports.TimePreset)
    .concat([{ value: "custom", label: "Custom" }]);
exports.ValidTimeZones = [
    "Etc/GMT+12",
    "Etc/GMT+11",
    "Etc/GMT+10",
    "Etc/GMT+9",
    "Etc/GMT+8",
    "Etc/GMT+7",
    "Etc/GMT+6",
    "Etc/GMT+5",
    "Etc/GMT+4",
    "Etc/GMT+3",
    "Etc/GMT+2",
    "Etc/GMT+1",
    "Etc/GMT+0",
    "Etc/GMT-1",
    "Etc/GMT-2",
    "Etc/GMT-3",
    "Etc/GMT-4",
    "Etc/GMT-5",
    "Etc/GMT-6",
    "Etc/GMT-7",
    "Etc/GMT-8",
    "Etc/GMT-9",
    "Etc/GMT-10",
    "Etc/GMT-11",
    "Etc/GMT-12"
];
exports.Operators = [
    "=",
    "!=",
    ">=",
    "<=",
    ">",
    "<"
];
var PrebidAdapter;
(function (PrebidAdapter) {
    PrebidAdapter["BEACH_FRONT"] = "beachfront";
    PrebidAdapter["FREEWHEEL_SSP"] = "freewheel-ssp";
    PrebidAdapter["RUBICON"] = "rubicon";
    PrebidAdapter["SPOTX_ADOS"] = "spotx-ados";
    PrebidAdapter["SPOTX"] = "spotx";
    PrebidAdapter["OPENX"] = "openx";
    PrebidAdapter["APP_NEXUS"] = "appnexus";
    PrebidAdapter["ONE_VIDEO"] = "oneVideo";
    PrebidAdapter["LKQD"] = "lkqd";
    PrebidAdapter["INDEX"] = "ix";
    PrebidAdapter["ADFORM_OPEN_RTB"] = "adformOpenRTB";
    PrebidAdapter["AUDIENCE_NETWORK"] = "audienceNetwork";
    PrebidAdapter["LOCKER_DOME"] = "lockerDome";
    PrebidAdapter["UNDERDOG_MEDIA"] = "underdogMedia";
    PrebidAdapter["SOVRN"] = "sovrn";
    PrebidAdapter["SONOBI"] = "sonobi";
    PrebidAdapter["SHARETHROUGH"] = "sharethrough";
    PrebidAdapter["PUBMATIC"] = "pubmatic";
    PrebidAdapter["PULSE_POINT"] = "pulsepoint";
    PrebidAdapter["ONE_DISPLAY"] = "oneDisplay";
    PrebidAdapter["ONE_MOBILE"] = "oneMobile";
    PrebidAdapter["RHYTHM_ONE"] = "rhythmone";
    PrebidAdapter["TRIPLE_LIFT"] = "triplelift";
    PrebidAdapter["TRUSTX"] = "trustx";
    PrebidAdapter["UNRULY"] = "unruly";
    PrebidAdapter["_33_ACROSS"] = "33across";
    PrebidAdapter["CRITEO"] = "criteo";
    PrebidAdapter["EMX_DIGITAL"] = "emx_digital";
    PrebidAdapter["IMPROVE_DIGITAL"] = "improvedigital";
    PrebidAdapter["MEDIA_NET"] = "medianet";
    PrebidAdapter["SMART_AD_SERVER"] = "smartadserver";
    PrebidAdapter["YIELDMO"] = "yieldmo";
    PrebidAdapter["COLOSSUS"] = "colossusssp";
    PrebidAdapter["TELARIA"] = "telaria";
    PrebidAdapter["CONVERSANT"] = "conversant";
    PrebidAdapter["GUMGUM"] = "gumgum";
    PrebidAdapter["UNDERTONE"] = "undertone";
    PrebidAdapter["RISE"] = "rise";
    PrebidAdapter["SMAATO"] = "smaato";
    PrebidAdapter["AMAZON"] = "amazon";
    PrebidAdapter["GRID"] = "grid";
    PrebidAdapter["ONE_TAG"] = "onetag";
    PrebidAdapter["VIDEOBYTE"] = "videobyte";
    PrebidAdapter["YAHOOSSP"] = "yahoossp";
    PrebidAdapter["AMX"] = "amx";
    PrebidAdapter["ADMAN"] = "adman";
    PrebidAdapter["ONE_FIFTY_TWO_MEDIA"] = "onefiftytwomedia";
    PrebidAdapter["ADYOULIKE"] = "adyoulike";
    PrebidAdapter["TEADS"] = "teads";
    PrebidAdapter["ZETA_GLOBAL_SSP"] = "zeta_global_ssp";
    PrebidAdapter["RICHAUDIENCE"] = "richaudience";
    PrebidAdapter["MINUTE_MEDIA"] = "minutemedia";
    PrebidAdapter["YANDEX"] = "yandex";
    PrebidAdapter["KRUSHMEDIA"] = "krushmedia";
    PrebidAdapter["RESET_DIGITAL"] = "resetdigital";
    PrebidAdapter["SMART_CLIP"] = "smartx";
    PrebidAdapter["SMILEWANTED"] = "smilewanted";
    PrebidAdapter["PGAM"] = "pgamssp";
    PrebidAdapter["OPENWEB"] = "openweb";
    PrebidAdapter["ANIVIEW"] = "aniview";
    PrebidAdapter["VIDAZOO"] = "vidazoo";
    PrebidAdapter["Nobid"] = "nobid";
    PrebidAdapter["STROEER_CORE"] = "stroeerCore";
    PrebidAdapter["KARGO"] = "kargo";
    PrebidAdapter["VIDOOMY"] = "vidoomy";
    PrebidAdapter["BOLDWIN"] = "boldwin";
    PrebidAdapter["SEEDTAG"] = "seedtag";
    PrebidAdapter["KUEEZRTB"] = "kueezrtb";
    PrebidAdapter["INSTICATOR"] = "insticator";
    PrebidAdapter["EPLANNING"] = "eplanning";
    PrebidAdapter["NEXT_MILLENNIUM"] = "nextMillennium";
    PrebidAdapter["OUTBRAIN"] = "outbrain";
    PrebidAdapter["ADTELLIGENT"] = "adtelligent";
    PrebidAdapter["ADAGIO"] = "adagio";
    PrebidAdapter["MINUTE_MEDIA_PLUS"] = "mmplus";
    PrebidAdapter["ADF"] = "adf";
    PrebidAdapter["IMDS"] = "imds";
    PrebidAdapter["AD_KERNEL"] = "adkernel";
})(PrebidAdapter = exports.PrebidAdapter || (exports.PrebidAdapter = {}));
exports.PrebidAdapters = [
    { value: PrebidAdapter.VIDAZOO, label: "Vidazoo" },
    { value: PrebidAdapter.BEACH_FRONT, label: "Beach Front" },
    { value: PrebidAdapter.FREEWHEEL_SSP, label: "Freewheel SSP" },
    { value: PrebidAdapter.RUBICON, label: "Rubicon" },
    { value: PrebidAdapter.SPOTX, label: "SpotX" },
    { value: PrebidAdapter.SPOTX_ADOS, label: "SpotX AdOS" },
    { value: PrebidAdapter.OPENX, label: "Open X" },
    { value: PrebidAdapter.APP_NEXUS, label: "AppNexus" },
    { value: PrebidAdapter.LKQD, label: "LKQD" },
    { value: PrebidAdapter.ONE_VIDEO, label: "One Video" },
    { value: PrebidAdapter.INDEX, label: "Index Exchange" },
    { value: PrebidAdapter.ADFORM_OPEN_RTB, label: "Adform Open RTB" },
    { value: PrebidAdapter.AUDIENCE_NETWORK, label: "Audience Network" },
    { value: PrebidAdapter.LOCKER_DOME, label: "Locker Dome" },
    { value: PrebidAdapter.UNDERDOG_MEDIA, label: "Underdog Media" },
    { value: PrebidAdapter.SOVRN, label: "Sovrn" },
    { value: PrebidAdapter.SONOBI, label: "Sonobi" },
    { value: PrebidAdapter.SHARETHROUGH, label: "Sharethrough" },
    { value: PrebidAdapter.PUBMATIC, label: "Pubmatic" },
    { value: PrebidAdapter.PULSE_POINT, label: "Pulse Point" },
    { value: PrebidAdapter.ONE_DISPLAY, label: "One Display" },
    { value: PrebidAdapter.ONE_MOBILE, label: "One Mobile" },
    { value: PrebidAdapter.RHYTHM_ONE, label: "Rhythm One" },
    { value: PrebidAdapter.TRIPLE_LIFT, label: "Triple Lift" },
    { value: PrebidAdapter.TRUSTX, label: "TrustX" },
    { value: PrebidAdapter.UNRULY, label: "Unruly" },
    { value: PrebidAdapter._33_ACROSS, label: "33 Across" },
    { value: PrebidAdapter.CRITEO, label: "Criteo" },
    { value: PrebidAdapter.EMX_DIGITAL, label: "EMX Digital" },
    { value: PrebidAdapter.IMPROVE_DIGITAL, label: "Improve Digital" },
    { value: PrebidAdapter.MEDIA_NET, label: "Media.net" },
    { value: PrebidAdapter.SMART_AD_SERVER, label: "Smart AdServer" },
    { value: PrebidAdapter.YIELDMO, label: "Yieldmo" },
    { value: PrebidAdapter.COLOSSUS, label: "Colossus" },
    { value: PrebidAdapter.TELARIA, label: "Telaria" },
    { value: PrebidAdapter.CONVERSANT, label: "Conversant" },
    { value: PrebidAdapter.GUMGUM, label: "GumGum" },
    { value: PrebidAdapter.UNDERTONE, label: "Undertone" },
    { value: PrebidAdapter.RISE, label: "Rise" },
    { value: PrebidAdapter.SMAATO, label: "Smaato" },
    { value: PrebidAdapter.AMAZON, label: "Amazon" },
    { value: PrebidAdapter.GRID, label: "Grid" },
    { value: PrebidAdapter.ONE_TAG, label: "One Tag" },
    { value: PrebidAdapter.VIDEOBYTE, label: "Videobyte" },
    { value: PrebidAdapter.YAHOOSSP, label: "Yahoo SSP" },
    { value: PrebidAdapter.AMX, label: "AMX" },
    { value: PrebidAdapter.ADMAN, label: "Adman" },
    { value: PrebidAdapter.ONE_FIFTY_TWO_MEDIA, label: "152 Media" },
    { value: PrebidAdapter.ADYOULIKE, label: "Adyoulike" },
    { value: PrebidAdapter.TEADS, label: "Teads" },
    { value: PrebidAdapter.ZETA_GLOBAL_SSP, label: "Zeta Global SSP" },
    { value: PrebidAdapter.RICHAUDIENCE, label: "Rich Audience" },
    { value: PrebidAdapter.MINUTE_MEDIA, label: "Minute Media" },
    { value: PrebidAdapter.YANDEX, label: "Yandex" },
    { value: PrebidAdapter.KRUSHMEDIA, label: "Krushmedia" },
    { value: PrebidAdapter.RESET_DIGITAL, label: "Reset Digital" },
    { value: PrebidAdapter.SMART_CLIP, label: "Smartclip" },
    { value: PrebidAdapter.SMILEWANTED, label: "Smilewanted" },
    { value: PrebidAdapter.PGAM, label: "PGAM" },
    { value: PrebidAdapter.OPENWEB, label: "OpenWeb" },
    { value: PrebidAdapter.ANIVIEW, label: "Aniview" },
    { value: PrebidAdapter.Nobid, label: "Nobid" },
    { value: PrebidAdapter.STROEER_CORE, label: "Stroeer Core" },
    { value: PrebidAdapter.KARGO, label: "Kargo" },
    { value: PrebidAdapter.VIDOOMY, label: "Vidoomy" },
    { value: PrebidAdapter.BOLDWIN, label: "Boldwin" },
    { value: PrebidAdapter.SEEDTAG, label: "Seed Tag" },
    { value: PrebidAdapter.KUEEZRTB, label: "Kueez RTB" },
    { value: PrebidAdapter.INSTICATOR, label: "Insticator" },
    { value: PrebidAdapter.EPLANNING, label: "Eplanning" },
    { value: PrebidAdapter.NEXT_MILLENNIUM, label: "Next Millennium" },
    { value: PrebidAdapter.OUTBRAIN, label: "Outbrain" },
    { value: PrebidAdapter.ADTELLIGENT, label: "Adtelligent" },
    { value: PrebidAdapter.ADAGIO, label: "Adagio" },
    { value: PrebidAdapter.MINUTE_MEDIA_PLUS, label: "Minute Media Plus" },
    { value: PrebidAdapter.ADF, label: "ADF (Adform New)" },
    { value: PrebidAdapter.IMDS, label: "IMDS" },
    { value: PrebidAdapter.AD_KERNEL, label: "Ad Kernel" },
];
var FilterOperators;
(function (FilterOperators) {
    FilterOperators["isAnyOf"] = "Is Any Of";
    FilterOperators["isNotAnyOf"] = "Is Not Any Of";
    FilterOperators["containAnyOf"] = "Contain Any Of";
    FilterOperators["notContainAnyOf"] = "Not Contain Any Of";
})(FilterOperators = exports.FilterOperators || (exports.FilterOperators = {}));
var PriceFloorMethod;
(function (PriceFloorMethod) {
    PriceFloorMethod["FLUID"] = "fluid";
    PriceFloorMethod["GROSS"] = "priceFloorGross";
})(PriceFloorMethod = exports.PriceFloorMethod || (exports.PriceFloorMethod = {}));
exports.PriceFloorMethods = [
    { value: PriceFloorMethod.FLUID, label: "Fluid" },
    { value: PriceFloorMethod.GROSS, label: "Price Floor Gross" }
];
var YahooSSPTemplate;
(function (YahooSSPTemplate) {
    YahooSSPTemplate["PUBID"] = "pubId";
    YahooSSPTemplate["DCN"] = "dcn";
})(YahooSSPTemplate = exports.YahooSSPTemplate || (exports.YahooSSPTemplate = {}));
exports.YahooSSPTemplates = [
    { value: YahooSSPTemplate.PUBID, label: "Pub Id" },
    { value: YahooSSPTemplate.DCN, label: "DCN" }
];
var ContextMenuItemsType;
(function (ContextMenuItemsType) {
    ContextMenuItemsType["fields"] = "fields";
    ContextMenuItemsType["groups"] = "groups";
    ContextMenuItemsType["filters"] = "filters";
    ContextMenuItemsType["constraints"] = "constraints";
    ContextMenuItemsType["subGroups"] = "subGroups";
})(ContextMenuItemsType = exports.ContextMenuItemsType || (exports.ContextMenuItemsType = {}));
var ReportHistoryStatus;
(function (ReportHistoryStatus) {
    ReportHistoryStatus["Finished"] = "Finished";
    ReportHistoryStatus["Error"] = "Error";
    ReportHistoryStatus["Processing"] = "Processing";
})(ReportHistoryStatus = exports.ReportHistoryStatus || (exports.ReportHistoryStatus = {}));
var ReportHistoryUrlAction;
(function (ReportHistoryUrlAction) {
    ReportHistoryUrlAction["Download"] = "download";
    ReportHistoryUrlAction["Reuse"] = "reuse";
    ReportHistoryUrlAction["Generate"] = "generate";
})(ReportHistoryUrlAction = exports.ReportHistoryUrlAction || (exports.ReportHistoryUrlAction = {}));
var ReportingDbType;
(function (ReportingDbType) {
    ReportingDbType["MemSql"] = "MemSql";
    ReportingDbType["BigQuery"] = "BigQuery";
    ReportingDbType["SnowFlake"] = "SnowFlake";
    ReportingDbType["MemSqlTemp"] = "MemSqlTemp";
    ReportingDbType["ClickHouse"] = "ClickHouse";
})(ReportingDbType = exports.ReportingDbType || (exports.ReportingDbType = {}));
var REPORT_VERTICAL_TYPE;
(function (REPORT_VERTICAL_TYPE) {
    REPORT_VERTICAL_TYPE["PLATFORM"] = "platform";
    REPORT_VERTICAL_TYPE["CONNECTION"] = "connection";
    REPORT_VERTICAL_TYPE["OPEN_RTB"] = "open_rtb";
})(REPORT_VERTICAL_TYPE = exports.REPORT_VERTICAL_TYPE || (exports.REPORT_VERTICAL_TYPE = {}));
